import React, {useState} from 'react';
import classes from './style.module.css';
import PropTypes from 'prop-types';
import {logInfo/*, logError*/} from '../../../util/log/logger'
import { Form, Button, Row } from 'react-bootstrap';

import { CHANGE_PASSWORD_FORM_FIELDS } from '../../../constants/Constants'

const ChangePasswordForm = props => {

    const [password, setPassword] = useState("");
    const [passwordNew, setPasswordNew] = useState("");
    const [passwordNewVerify, setPasswordNewVerify] = useState("");
    const [inputErrorMessage, setInputErrorMessage] = useState(null);


    const compareInputs = () => {
        return passwordNew === passwordNewVerify && props.password === password
    }

    const changePasswordHandler = async () => {
        logInfo("changePasswordHandler called.")
        if(compareInputs()) {
            logInfo("changePasswordHandler | new and confirm passwords matched")
            setInputErrorMessage(null)
            await props.changePasswordClicked(passwordNew)
        }else {
            logInfo("changePasswordHandler | mismatch in new and confirm passwords")
            setInputErrorMessage("Incorrect passwords. Please check and re-enter again")
        }
    }

    let fieldErrors = null;
    if(inputErrorMessage) {
        fieldErrors = <div className={classes.FieldErrors}>
                        {inputErrorMessage}
                      </div>
    }

    return (
        <div className={classes.ChangePasswordForm}>
            <div className={classes.FormTitle}>{props.title}</div>
            <div className={classes.FormSubtitle}>Change Your Password</div>
            <div className={classes.PasswordPolicy}>
                Password minimum length is 8 and should adhere to the password policy.
            </div>

            <div className={classes.FormGroup}>
                <label className={classes.FormLabel} htmlFor="loginFormPasswordInput">
                    {CHANGE_PASSWORD_FORM_FIELDS.PASSWORD_TEXT.label}
                </label>
                <input
                    id="loginFormPasswordInput"
                    className={classes.FormControl}
                    key={CHANGE_PASSWORD_FORM_FIELDS.PASSWORD_TEXT.key}
                    type="password"
                    placeholder={CHANGE_PASSWORD_FORM_FIELDS.PASSWORD_TEXT.placeHolder}
                    value={password}
                    onChange={(event) => { setPassword(event.target.value) }} />
            </div>

            <div className={classes.FormGroup}>
                <label className={classes.FormLabel} htmlFor="loginFormPasswordInputNew">
                    {CHANGE_PASSWORD_FORM_FIELDS.PASSWORD_NEW_TEXT.label}
                </label>
                <input
                    id="loginFormPasswordInputNew"
                    className={classes.FormControl}
                    key={CHANGE_PASSWORD_FORM_FIELDS.PASSWORD_NEW_TEXT.key}
                    type="password"
                    placeholder={CHANGE_PASSWORD_FORM_FIELDS.PASSWORD_NEW_TEXT.placeHolder}
                    value={passwordNew}
                    onChange={(event) => { setPasswordNew(event.target.value); setInputErrorMessage(null) }} />
            </div>

            <div className={classes.FormGroup}>
                <label className={classes.FormLabel} htmlFor="loginFormPasswordInputNewVerify">
                    {CHANGE_PASSWORD_FORM_FIELDS.PASSWORD_NEW_VERIFY_TEXT.label}
                </label>
                <input
                    id="loginFormPasswordInputNewVerify"
                    className={classes.FormControl}
                    key={CHANGE_PASSWORD_FORM_FIELDS.PASSWORD_NEW_VERIFY_TEXT.key}
                    type="password"
                    placeholder={CHANGE_PASSWORD_FORM_FIELDS.PASSWORD_NEW_VERIFY_TEXT.placeHolder}
                    value={passwordNewVerify}
                    onChange={(event) => { setPasswordNewVerify(event.target.value); setInputErrorMessage(null) }} />
            </div>

            {fieldErrors}

            <button
                type="button"
                className={classes.SubmitButton}
                onClick={changePasswordHandler}>
                {CHANGE_PASSWORD_FORM_FIELDS.CHANGE_PASSWORD_BUTTON.label}
            </button>
        </div>
    )
}

ChangePasswordForm.propTypes = {
    password: PropTypes.string.isRequired,
    changePasswordClicked: PropTypes.func.isRequired
}

export default ChangePasswordForm